import { render } from "./icon_menu.svg?vue&type=template&id=b7d6abdc?inline"
const script = {}
script.render = render

export default script